<div class="notification-container">
  <button mat-icon-button [matMenuTriggerFor]="menu" class="notification-button">
    <mat-icon
      [class.no-notifications]="cantidadNoLeidas() === 0"
      matBadge="{{ cantidadNoLeidas() }}"
      matBadgeColor="warn"
      [matBadgeHidden]="cantidadNoLeidas() === 0"
      class="badge-animated">
      notifications
    </mat-icon>
  </button>

  <mat-menu #menu="matMenu" class="notification-menu">
    <ng-container *ngIf="notificaciones.length > 0; else sinNotificaciones">
      <div *ngFor="let notificacion of notificaciones" class="notification-item" [class.eliminando]="estaEliminando(notificacion)">
        <div class="notification-content">
          <div class="notification-header">
            <span class="asunto">{{ notificacion.asunto || 'Sin asunto' }}</span>
          </div>
          <div class="contenido">{{ notificacion.contenido || 'Sin contenido' }}</div>
        </div>

        <button
          mat-icon-button
          color="primary"
          class="small-icon-btn"
           (click)="marcarComoLeida(notificacion); $event.stopPropagation()"
          [disabled]="estaEliminando(notificacion)">
          <mat-icon>{{ estaEliminando(notificacion) ? 'hourglass_empty' : 'done' }}</mat-icon>
        </button>
        <mat-divider></mat-divider>
      </div>

      <button
        mat-flat-button
        color="primary"
        class="w-full marcar-todas"
        (click)="marcarTodasComoLeidas(); $event.stopPropagation()"
        [disabled]="notificacionesEliminando.size > 0">
        <mat-icon class="mr-2">done_all</mat-icon>
        {{ notificacionesEliminando.size > 0 ? 'Procesando...' : 'Marcar todas como leídas' }}
      </button>
    </ng-container>

    <ng-template #sinNotificaciones>
      <div class="sin-notificaciones-container">
        <mat-icon class="sin-notificaciones-icon">notifications_off</mat-icon>
        <p class="sin-notificaciones-texto">Sin notificaciones nuevas</p>
        <span class="sin-notificaciones-subtexto">Te notificaremos cuando llegue algo nuevo</span>
      </div>
    </ng-template>
  </mat-menu>
</div>
